import React from 'react';

const BRAND_VERSION = '3.1.1-audit';

type BrandVariant = 'logo' | 'icon' | 'mark';

type BrandProps = {
  compact?: boolean;
  variant?: BrandVariant;
  className?: string;
  priority?: boolean;
};

export function Brand({
  compact = false,
  variant,
  className = '',
  priority = false,
}: BrandProps) {
  const selectedVariant: BrandVariant = variant ?? (compact ? 'icon' : 'logo');
  const loading = priority ? 'eager' : 'lazy';
  const fetchPriority = priority ? 'high' : 'auto';

  if (selectedVariant === 'mark') {
    return (
      <div className={`brand brand-mark-only ${className}`.trim()}>
        <picture>
          <source
            srcSet={`/brand/app_mark_64.webp?v=${BRAND_VERSION} 64w, /brand/app_mark_128.webp?v=${BRAND_VERSION} 128w`}
            sizes="64px"
            type="image/webp"
          />
          <img
            className="brand-mark-new"
            src={`/brand/app_mark.png?v=${BRAND_VERSION}`}
            alt="English Forge 365"
            width={128}
            height={128}
            loading={loading}
            decoding="async"
            fetchPriority={fetchPriority}
            draggable={false}
          />
        </picture>
      </div>
    );
  }

  if (selectedVariant === 'icon') {
    return (
      <div className={`brand brand-compact ${className}`.trim()}>
        <picture>
          <source
            srcSet={`/brand/app_icon_96.webp?v=${BRAND_VERSION} 96w, /brand/app_icon_192.webp?v=${BRAND_VERSION} 192w`}
            sizes="(max-width: 440px) 38px, 44px"
            type="image/webp"
          />
          <img
            className="brand-icon-new"
            src={`/brand/app_icon.png?v=${BRAND_VERSION}`}
            alt="English Forge 365"
            width={192}
            height={192}
            loading={loading}
            decoding="async"
            fetchPriority={fetchPriority}
            draggable={false}
          />
        </picture>
      </div>
    );
  }

  return (
    <div className={`brand brand-new ${className}`.trim()}>
      <picture>
        <source
          srcSet={`/brand/logo_primary_360.webp?v=${BRAND_VERSION} 360w, /brand/logo_primary_720.webp?v=${BRAND_VERSION} 720w`}
          sizes="(max-width: 780px) 180px, (max-width: 1200px) 200px, 220px"
          type="image/webp"
        />
        <img
          className="brand-logo-new"
          src={`/brand/logo_primary.png?v=${BRAND_VERSION}`}
          alt="English Forge 365"
          width={720}
          height={240}
          loading={loading}
          decoding="async"
          fetchPriority={fetchPriority}
          draggable={false}
        />
      </picture>
    </div>
  );
}
